import { HttpParams } from '@angular/common/http';
import { ClSortOrder } from '@corelabs/angular/ui';
import { GetUsersValue } from './get-users.value';

export class GetUsersValueDto {
    page: number;
    limit: number;
    sort?: string;
    order?: ClSortOrder;

    constructor(data: GetUsersValue) {
        this.page = data.page;
        this.limit = data.limit;
        this.sort = data.sort;
        this.order = data.order;
    }

    toHttpParams(): HttpParams {
        let params = new HttpParams().set('page', this.page).set('limit', this.limit);

        if (this.sort && this.order) {
            params = params.set('sort', this.sort).set('order', this.order);
        }

        return params;
    }
}
